import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import Vue3VideoPlay from 'vue3-video-play'
import 'vue3-video-play/dist/style.css'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/el-message.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
createApp(App)
  .use(router)
  .use(Vue3VideoPlay)
  .use(ElementPlus, { locale: zhCn })
  .mount('#app')
